import ExpertProfileVisibilityModalComponent from './expert-profile-visibility-modal.component'

const ExpertProfileVisibilityModalModule = angular.module('cdbl.expert-profile-visibility-modal', [

])
  .component('cdblExpertProfileVisibilityModal', ExpertProfileVisibilityModalComponent)
  .name

export default ExpertProfileVisibilityModalModule
